/**
 * Federated Auth0 connections offered on the login page.
 * Exactly one auto-redirects; more than one falls back to a manual picker.
 */
export interface FederatedConnection {
  connection: string;
  labelKey: string;
  icon: string;
}

export const FEDERATED_CONNECTIONS: FederatedConnection[] = [
  { connection: 'bc-idp', labelKey: 'auth.login.federated', icon: 'mdi:cloud-outline' },
];

export function getSingleAutoConnection(connections: FederatedConnection[]): FederatedConnection | null {
  return connections.length === 1 ? connections[0] : null;
}
